import React, {Fragment, useEffect, useRef, useState} from "react";
import {Link, NavLink, useLocation, useParams} from "react-router-dom";
import '../../assets/css/home.css';
import axios from "axios";
import clientconfigwebapp, {
    Agent_by_user_get_appbk,
    check_login_appbk, empty_bk,
    FormatNumberByhkh,
    get_first_last_name_local, modal_select_agent_show_hide,
    scrollTo_uphk, Token_get_appbk
} from "../../clientconfigwebapp";
import {toast, ToastContainer} from "react-toastify";

import Master_Front from "../../pages/Master_Front";


import {Grid, Typography, Box, Container, Card, CardContent} from '@mui/material';



const services = [
    {
        title: 'بازاریابی و فروش محصولات عمده',
        svg: '<svg width="73" height="72" viewBox="0 0 73 72" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.25" width="72" height="72" rx="18" fill="#FF9828"/><path d="M36.2497 27.3334H18.9163C17.7671 27.3334 16.6649 27.79 15.8522 28.6026C15.0396 29.4153 14.583 30.5175 14.583 31.6667V40.3334C14.583 41.4827 15.0396 42.5849 15.8522 43.3975C16.6649 44.2102 17.7671 44.6667 18.9163 44.6667H21.083V53.3334C21.083 53.9081 21.3113 54.4592 21.7176 54.8655C22.1239 55.2718 22.675 55.5001 23.2497 55.5001H27.583C28.1576 55.5001 28.7087 55.2718 29.1151 54.8655C29.5214 54.4592 29.7497 53.9081 29.7497 53.3334V44.6667H36.2497L47.083 53.3334V18.6667L36.2497 27.3334ZM42.7497 43.8001L38.4163 40.3334H18.9163V31.6667H38.4163L42.7497 28.2001V43.8001ZM56.833 36.0001C56.833 39.7051 54.753 43.0634 51.4163 44.6667V27.3334C54.7313 28.9584 56.833 32.3167 56.833 36.0001Z" fill="white"/></svg>',
        description: 'سایت بازارانو به شرکت‌ها و فروشندگان عمده امکان می‌دهد محصولات خود را در پلتفرم قرار داده و بازاریابی و فروش این محصولات را انجام دهند. این شامل نمایش و تبلیغ محصولات، قراردادن قیمت‌ها و مذاکره با خریداران ممکن است.',
        cssClass: ''
    },
    {
        title: 'جستجوی محصولات',
        svg: '<svg width="73" height="72" viewBox="0 0 73 72" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.5" width="72" height="72" rx="18" fill="#FF9828"/><path d="M58.1663 38.1666C58.1663 39.3149 57.7113 40.4199 56.888 41.2216L55.9997 42.1316C55.8047 35.9349 51.3197 30.8433 45.4047 29.7382L34.333 18.6666H19.1663V33.8333L30.238 44.9049C31.343 50.8199 36.4347 55.3049 42.6313 55.4999L41.7213 56.3882C40.9197 57.2116 39.8147 57.6666 38.6663 57.6666C37.518 57.6666 36.4347 57.2116 35.6113 56.4099L16.1113 36.9099C15.288 36.0866 14.833 34.9816 14.833 33.8333V18.6666C14.833 16.2833 16.783 14.3333 19.1663 14.3333H34.333C35.4813 14.3333 36.5863 14.7883 37.388 15.5899L56.888 35.0899C57.7113 35.9132 58.1663 37.0182 58.1663 38.1666ZM21.333 24.0833C21.333 25.8816 22.7847 27.3333 24.583 27.3333C26.3813 27.3333 27.833 25.8816 27.833 24.0833C27.833 22.2849 26.3813 20.8333 24.583 20.8333C22.7847 20.8333 21.333 22.2849 21.333 24.0833ZM43.238 32.9883C37.8213 32.9883 33.488 37.3216 33.488 42.7382C33.488 48.1549 37.8213 52.4883 43.238 52.4883C45.1663 52.4883 46.8997 51.9466 48.4163 51.0149L55.1547 57.6666L58.1663 54.6549L51.493 47.9166C52.4463 46.4432 52.988 44.6666 52.988 42.7382C52.988 37.3216 48.6547 32.9883 43.238 32.9883ZM43.238 37.3216C46.2497 37.3216 48.6547 39.7482 48.6547 42.7382C48.6547 45.7282 46.2497 48.1549 43.238 48.1549C40.2263 48.1549 37.8213 45.7499 37.8213 42.7382C37.8213 39.7266 40.248 37.3216 43.238 37.3216Z" fill="white"/></svg>',
        description: 'کاربران سایت بازارانو می‌توانند از طریق سیستم جستجوی سایت به دنبال محصولات مورد نیاز خود بگردند. این شامل دسته‌بندی‌های مختلف محصولات، ویژگی‌ها، برندها و سایر پارامترهای قابل تنظیم است.',
        cssClass: ''
    },
    {
        title: 'قیمت‌گذاری و مذاکره',
        svg: '<svg width="73" height="72" viewBox="0 0 73 72" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.75" width="72" height="72" rx="18" fill="#F9A537"/><path d="M44.1163 44.6667C43.4663 44.6667 42.8163 44.0167 42.8163 43.3667C42.8163 42.7167 43.4663 42.0667 44.1163 42.0667C44.7663 42.0667 45.4163 42.7167 45.4163 43.3667C45.4163 44.0167 44.7663 44.6667 44.1163 44.6667ZM57.983 48.5667L50.183 40.7667C49.7497 40.5501 49.3163 40.3334 48.883 40.3334H42.8163C41.9497 40.3334 41.083 41.2001 41.083 42.0667V48.1334C41.083 48.5667 41.2997 49.0001 41.5163 49.4334L49.3163 57.2334C49.533 57.4501 49.9663 57.6667 50.6163 57.6667C51.2663 57.6667 51.483 57.4501 51.9163 57.2334L57.983 51.1667C58.1997 50.9501 58.4163 50.5167 58.4163 49.8667C58.4163 49.4334 58.1997 49.0001 57.983 48.5667ZM32.4163 18.6667C27.6497 18.6667 23.7497 22.5667 23.7497 27.3334C23.7497 32.1001 27.6497 36.0001 32.4163 36.0001C37.183 36.0001 41.083 32.1001 41.083 27.3334C41.083 22.5667 37.183 18.6667 32.4163 18.6667ZM32.4163 23.0001C34.7997 23.0001 36.7497 24.9501 36.7497 27.3334C36.7497 29.7167 34.7997 31.6667 32.4163 31.6667C30.033 31.6667 28.083 29.7167 28.083 27.3334C28.083 24.9501 30.033 23.0001 32.4163 23.0001ZM32.4163 38.1667C26.5663 38.1667 15.083 40.9834 15.083 46.8334V53.3334H39.3497L38.483 52.4668C37.6163 51.6001 36.9663 50.5168 36.7497 49.2167H19.1997V46.8334C19.1997 45.5334 25.9163 42.2834 32.4163 42.2834C33.933 42.2834 35.4497 42.5001 36.7497 42.7167V42.0667C36.7497 40.7667 37.183 39.6834 37.833 38.8167C35.883 38.3834 33.933 38.1667 32.4163 38.1667Z" fill="white"/></svg>',
        description: 'سایت بازارانو امکان قراردادن قیمت برای محصولات را فراهم می‌کند. همچنین، خریداران و فروشندگان می‌توانند در مورد قیمت و شرایط فروش مذاکره کنند تا به توافق برسند.',
        cssClass: ''
    },
    {
        title: 'ارتباط با فروشندگان و خریداران',
        svg: '<svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="72" height="72" rx="18" fill="#F9A537"/><path d="M42.4997 18.6666V33.8333H21.2013L18.6663 36.3682V18.6666H42.4997ZM44.6663 14.3333H16.4997C15.925 14.3333 15.3739 14.5615 14.9676 14.9679C14.5613 15.3742 14.333 15.9253 14.333 16.4999V46.8332L22.9997 38.1666H44.6663C45.241 38.1666 45.7921 37.9383 46.1984 37.532C46.6047 37.1257 46.833 36.5746 46.833 35.9999V16.4999C46.833 15.9253 46.6047 15.3742 46.1984 14.9679C45.7921 14.5615 45.241 14.3333 44.6663 14.3333ZM55.4997 22.9999H51.1663V42.4999H22.9997V46.8332C22.9997 47.4079 23.2279 47.959 23.6343 48.3653C24.0406 48.7716 24.5917 48.9999 25.1663 48.9999H48.9997L57.6663 57.6666V25.1666C57.6663 24.5919 57.4381 24.0408 57.0317 23.6345C56.6254 23.2282 56.0743 22.9999 55.4997 22.9999Z" fill="white"/></svg>',
        description: 'از طریق سایت بازارنو، کاربران می‌توانند با یکدیگر ارتباط برقرار کنند، سوالات را مطرح کنند و جزئیات مربوط به فروش و خرید را بررسی کنند.',
        cssClass: ''
    },
];
const About_Us = (props) => {
    const location_get_urlbk = useLocation();

    /*  start profile */
    const [wallet_balance, setData_wallet_balance] = useState('0');
    const [first_name_profile, setData_first_name_profile] = useState('');
    const [last_name_profile, setData_last_name_profile] = useState('');
    /*  end profile */


    const [data_slider_list, set_data_slider_list] = useState([]);
    const [data_paged_info, set_data_paged_info] = useState([]);

    const imgBaseUrl = String(clientconfigwebapp.webappurl);


    useEffect(() => {

        Load_api_page();


    }, [location_get_urlbk]);


    const Load_api_page = () => {

        var config = null;

        if (check_login_appbk() == true) {
            config = {
                headers: {Authorization: `Bearer ${Token_get_appbk()}`}
            };
        }


        const data_form = null;

        axios.post(`${clientconfigwebapp.siteurl}api/v1/home-get-data/`, data_form, config)
            .then((res) => {


                if (String(res.data.data).length > 0) {


                    if (String(res.data.wallet_inventory).length > 0) {
                        setData_wallet_balance(res.data.wallet_inventory);
                    }
                    if (!empty_bk(res.data.first_name_profile)) {
                        setData_first_name_profile(res.data.first_name_profile);
                        localStorage.setItem('first_name_Get', res.data.first_name_profile);
                    }
                    if (!empty_bk(res.data.last_name_profile)) {
                        setData_last_name_profile(res.data.last_name_profile);
                        localStorage.setItem('last_name_Get', res.data.last_name_profile);
                    }


                } else {
                    if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }

            }).catch((err) => {
            /// Setloadinghkfullshow("false");
            toast.error('خطای اتصال به سرور کد 543534', {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        });


    }


    return (


        <Fragment>

            <Master_Front wallet_balance={wallet_balance} first_name_profile={first_name_profile}
                          last_name_profile={last_name_profile}>

                <ToastContainer/>


                <style jsx>{`
                    .h1-aboutus {

                        font-size: 19px;
                        font-weight: bold;
                        display: block;
                        margin-bottom: 8px;
                        font-family: 'iran';
                    }

                    .description-aboutus {
                        font-family: 'iran';
                        font-style: normal;
                        font-weight: 400;
                        font-size: 13px;
                        line-height: 1.9;
                        text-align: justify;
                        color: #1F2937;
                    }


                    .aboutus_seca_right {
                        display: flex;
                        flex-direction: column;
                        align-content: center;
                        justify-content: center;
                        align-items: flex-start;
                    }

                    .aboutus_seca_left {
                        display: flex;
                        flex-direction: column;
                        align-content: center;
                        justify-content: center;
                        align-items: flex-end;
                    }

                    .aboutus_seca_left img {
                        width: 68% !important;
                    }


                    .aboutus_title_main_section_b {
                        display: flex;
                        flex-direction: column;
                        align-content: center;
                        justify-content: center;
                        align-items: center;
                        font-size: 19px;
                        font-weight: bold;
                        color: black;
                        margin-bottom: 8px;
                        margin-top: 55px;
                    }


                    .aboutus_section_b_desc {
                        text-align: center;
                        width: 100%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        align-content: center;
                        margin-bottom: 71px;
                        padding-right: 30%;
                        padding-left: 30%;
                        line-height: 1.6;
                        font-size: 14px;
                        color: #1F2937;
                    }


                    .card_box_about_us_services {
                        box-sizing: border-box;
                        height: 313px;
                        border: 0.5px solid #9CA3AF;
                        backdrop-filter: blur(4px);
                        border-radius: 13px;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        padding-top: 36px;
                        padding-right: 24px;
                        padding-left: 24px;
                        padding-bottom: 17px;
                        align-content: center;

                    }


                    .card_boxabus_services_desc {
                        text-align: justify;
                        font-size: 13px;
                        padding-top: 11px;
                        color: #374151;
                        line-height: 1.6;
                    }

                    h3.card_boxabus_services_title {
                        display: block;
                        font-size: 16px;
                        font-weight: bold;
                        padding-top: 10px;
                        text-align: center;
                    }

                    .svg_cardboxabus_services {
                        display: flex;
                        flex-direction: column;
                        align-content: center;
                        justify-content: center;
                        align-items: center;
                    }

                    .sec_desctiption_and_img_right {
                        display: flex;
                        flex-direction: column;
                        align-content: center;
                        justify-content: center;
                        align-items: flex-start;
                    }

                    .aboutus_title_sec_c {
                        font-weight: bold;
                        font-family: 'iran';
                        font-size: 18px;
                        margin-top: 7px;
                        margin-bottom: 7px;
                    }
                    p.aboutus_desc_sec_c {
                        font-family: 'iran';
                        font-size: 14px;
                        line-height: 1.6;
                        color: #1F2937;
                        text-align: justify;
                    }
                    .sec_desctiption_and_img_left img {
                        width: 65% !important;
                    }

                    .sec_desctiption_and_img_left {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: flex-end;
                        align-content: center;
                    }
                    
                    

                `}</style>


                <Box py={4}>
                    <Grid container spacing={4}>

                        <Grid className={"aboutus_seca_right"} item xs={12} md={6}>
                            <h1 className={"h1-aboutus"}>درباره بازارانو</h1>
                            <p className={"description-aboutus"}>
                                 در بازارنو، ما با بهره‌گیری از سال‌ها تجربه در زمینه تجارت، صادرات و واردات و اجرای پروژه‌های متعدد دانشگاهی و بین‌المللی ، به یک پلتفرم تخصصی و معتبر در حوزه خرید و فروش عمده تبدیل شده‌ایم. تیم ما متشکل از افراد حرفه‌ای و متخصص است که با شناخت کامل از بازار و مهارت‌های تخصصی خود، به ارائه خدماتی دقیق و کاربردی در این حوزه می‌پردازند.
                            </p>
                        </Grid>


                        <Grid className={"aboutus_seca_left"} item xs={12} md={6}>
                            <img src={`${imgBaseUrl}images/aboutus/1.png`} alt="About Us"/>
                        </Grid>
                    </Grid>

                    <Box my={4}>
                        <div className={"aboutus_title_main_section_b"}>
                            <svg style={{"marginBottom": "12px", "display": "block"}} width={43} height={42}
                                 viewBox="0 0 43 42" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M27.7822 22.7675C22.1122 22.7675 17.4922 18.1475 17.4922 12.4775C17.4922 6.80751 22.1122 2.1875 27.7822 2.1875C33.4522 2.1875 38.0722 6.80751 38.0722 12.4775C38.0722 18.1475 33.4522 22.7675 27.7822 22.7675ZM27.7822 4.8125C23.5647 4.8125 20.1172 8.24251 20.1172 12.4775C20.1172 16.7125 23.5472 20.1425 27.7822 20.1425C32.0172 20.1425 35.4472 16.7125 35.4472 12.4775C35.4472 8.24251 31.9997 4.8125 27.7822 4.8125Z"
                                    fill="#01A3D4"/>
                                <path
                                    d="M11.6302 35.3325C7.93771 35.3325 4.92773 32.3225 4.92773 28.63C4.92773 24.9375 7.93771 21.9275 11.6302 21.9275C15.3227 21.9275 18.3327 24.9375 18.3327 28.63C18.3327 32.3225 15.3227 35.3325 11.6302 35.3325ZM11.6302 24.5525C9.39021 24.5525 7.55273 26.3725 7.55273 28.63C7.55273 30.87 9.37271 32.7075 11.6302 32.7075C13.8702 32.7075 15.7077 30.8875 15.7077 28.63C15.7077 26.39 13.8702 24.5525 11.6302 24.5525Z"
                                    fill="#01A3D4"/>
                                <path
                                    d="M29.5855 39.8125C26.383 39.8125 23.793 37.205 23.793 34.02C23.793 30.8175 26.4005 28.2275 29.5855 28.2275C32.7705 28.2275 35.378 30.835 35.378 34.02C35.378 37.205 32.7705 39.8125 29.5855 39.8125ZM29.5855 30.835C27.8355 30.835 26.418 32.2525 26.418 34.0025C26.418 35.7525 27.8355 37.17 29.5855 37.17C31.3355 37.17 32.753 35.7525 32.753 34.0025C32.753 32.27 31.3355 30.835 29.5855 30.835Z"
                                    fill="#01A3D4"/>
                            </svg>
                            خدماتی که بازاراتو ارائه می‌دهد
                        </div>

                        <p className={"aboutus_section_b_desc"}>
                            بازاراتو با ارائه خدمات متنوع از جمله تأمین کالا، حمل‌ونقل، مشاوره حقوقی و تبلیغات، به شما در خرید عمده محصولات باکیفیت و دسترسی به بهترین عرضه‌کنندگان عمده کمک می‌کند.
                        </p>


                        <Grid container spacing={4} justifyContent="center">
                            {services.map((service, index) => (
                                <Grid item xs={12} md={3} key={index}>
                                    <div className={`card_box_about_us_services ${service.cssClass}`}>
                                        <div className={"card_boxabus_services"}>
                                            <div className="svg_cardboxabus_services"
                                                 dangerouslySetInnerHTML={{__html: service.svg}}/>
                                            <h3 className={"card_boxabus_services_title"}>
                                                {service.title}
                                            </h3>
                                            <div className={"card_boxabus_services_desc"}>
                                                {service.description}
                                            </div>
                                        </div>
                                    </div>
                                </Grid>
                            ))}
                        </Grid>


                    </Box>







                    <Grid className={"sec_desctiption_and_img"} container spacing={4}>
                        <Grid className={"sec_desctiption_and_img_right"} item xs={12} md={6}>
                            <svg width={42} height={42} viewBox="0 0 42 42" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M29.2256 33.2149H12.7756C12.0406 33.2149 11.2181 32.6374 10.9731 31.9374L3.72809 11.6724C2.69559 8.76738 3.90309 7.87488 6.38809 9.65988L13.2131 14.5424C14.3506 15.3299 15.6456 14.9274 16.1356 13.6499L19.2156 5.44238C20.1956 2.81738 21.8231 2.81738 22.8031 5.44238L25.8831 13.6499C26.3731 14.9274 27.6681 15.3299 28.7881 14.5424L35.1931 9.97488C37.9231 8.01488 39.2356 9.01238 38.1156 12.1799L31.0456 31.9724C30.7831 32.6374 29.9606 33.2149 29.2256 33.2149Z"
                                    stroke="#01A3D4" strokeWidth="2.75" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M11.375 38.5H30.625" stroke="#01A3D4" strokeWidth="2.75" strokeLinecap="round"
                                      strokeLinejoin="round"/>
                                <path d="M16.625 24.5H25.375" stroke="#01A3D4" strokeWidth="2.75" strokeLinecap="round"
                                      strokeLinejoin="round"/>
                            </svg>
                            <span className={"aboutus_title_sec_c"}> ماموریت ما</span>
                            <p className={"aboutus_desc_sec_c"}>
                                 ماموریت ما در بازارانو ایجاد یک پلتفرم مطمئن و کارآمد برای خرید عمده محصولات باکیفیت در ایران است. ما به خریداران عمده این امکان را می‌دهیم که به‌راحتی و بدون واسطه به فروشندگان عمده دسترسی پیدا کنند و نیازهای خود را برآورده سازند. با فراهم کردن اطلاعات دقیق و به‌روز از تولیدکنندگان عمده و عرضه‌کنندگان عمده، بازارانو تلاش می‌کند تا فرآیند خرید عمده را تسهیل کرده و به خریداران عمده کمک کند بهترین انتخاب‌ها را داشته باشند.
                            <br/>
                            <br/>
                                علاوه بر این، ماموریت ما در بازارانو حمایت از فروشندگان عمده برای گسترش بازار و افزایش فروش محصولات عمده خود است. ما با ارائه ابزارهای تبلیغاتی و امکانات ویژه، به فروشندگان عمده کمک می‌کنیم تا محصولات عمده خود را به خریداران بیشتری معرفی کنند. در این راستا، خدمات ما به ایجاد ارتباطات مستقیم و مؤثر بین خریداران عمده و فروشندگان عمده کمک کرده و زمینه‌ساز یک بازار شفاف و پویا در حوزه خرید عمده می‌شود.
                            </p>
                        </Grid>

                        <Grid className={"sec_desctiption_and_img_left"} item xs={12} md={6}>
                            <img src={`${imgBaseUrl}images/aboutus/2.png`} alt="Vision" style={{width: '100%'}}/>
                        </Grid>
                    </Grid>


                    <Grid className={"sec_desctiption_and_img"} container spacing={4}>

                        <Grid className={"sec_desctiption_and_img_left"} item xs={12} md={6}>
                            <img src={`${imgBaseUrl}images/aboutus/3.png`} alt="Vision" style={{width: '100%'}}/>
                        </Grid>

                        <Grid className={"sec_desctiption_and_img_right"} item xs={12} md={6}>
                            <svg width="42" height="42" viewBox="0 0 42 42" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path d="M9.0127 3.5V38.5" stroke="#01A3D4" stroke-width="2.75" stroke-miterlimit="10"
                                      stroke-linecap="round" stroke-linejoin="round"/>
                                <path
                                    d="M9.0127 7H28.6127C33.3377 7 34.3877 9.625 31.0627 12.95L28.9627 15.05C27.5627 16.45 27.5627 18.725 28.9627 19.95L31.0627 22.05C34.3877 25.375 33.1627 28 28.6127 28H9.0127"
                                    stroke="#01A3D4" stroke-width="2.75" stroke-miterlimit="10" stroke-linecap="round"
                                    stroke-linejoin="round"/>
                            </svg>

                            <span className={"aboutus_title_sec_c"}>چشم انداز ما</span>
                            <p className={"aboutus_desc_sec_c"}>
                                چشم‌انداز ما در بازارانو تبدیل شدن به برترین پلتفرم آنلاین برای خرید عمده محصولات در ایران است. ما هدف داریم با ارائه یک بازار کارآمد و مطمئن، خریداران عمده و فروشندگان عمده را به یکدیگر متصل کرده و فرآیند خرید و فروش عمده را تسهیل کنیم. با گسترش دامنه خدمات خود و بهبود مستمر سیستم‌های جستجو و ارتباطی، امیدواریم فضایی را فراهم آوریم که در آن هر خریدار و فروشنده عمده بتواند به آسانی نیازهای خود را برآورده کند و تجربه‌ای بی‌نظیر از خرید عمده داشته باشد.
                          <br/>
                          <br/>
                                در چشم‌انداز ما، بازارانو نه‌تنها به عنوان یک مرکز عمده فروشی شناخته می‌شود، بلکه به مرجعی برای تبادل اطلاعات و تجربیات تجاری تبدیل می‌شود. ما به دنبال ایجاد یک جامعه تجاری پویا هستیم که در آن خریداران عمده و فروشندگان عمده بتوانند از تجربیات یکدیگر بهره‌مند شوند و با همکاری‌های متقابل، کیفیت خدمات و محصولات خود را بهبود بخشند. با تکیه بر نوآوری و تکنولوژی‌های روز، قصد داریم به خریداران این اطمینان را بدهیم که همواره بهترین و مناسب‌ترین گزینه‌های خرید عمده را در اختیار دارند.
                            </p>
                        </Grid>


                    </Grid>


                    <Grid className={"sec_desctiption_and_img"} container spacing={4}>
                        <Grid className={"sec_desctiption_and_img_right"} item xs={12} md={6}>
                            <svg width="42" height="42" viewBox="0 0 42 42" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M30.1351 3.5H15.6802C14.9802 3.5 14.3152 3.74501 13.7727 4.16501L9.94016 7.22751C8.40016 8.45251 8.40016 10.78 9.94016 12.005L13.7727 15.0675C14.3152 15.505 14.9977 15.7325 15.6802 15.7325H30.1351C31.8326 15.7325 33.1976 14.3675 33.1976 12.67V6.54498C33.1976 4.86498 31.8326 3.5 30.1351 3.5Z"
                                    stroke="#01A3D4" stroke-width="2.625" stroke-linecap="round"
                                    stroke-linejoin="round"/>
                                <path
                                    d="M11.8994 21H26.3544C27.0544 21 27.7195 21.245 28.262 21.665L32.0945 24.7275C33.6345 25.9525 33.6345 28.28 32.0945 29.505L28.262 32.5675C27.7195 33.005 27.0369 33.2325 26.3544 33.2325H11.8994C10.2019 33.2325 8.83691 31.8675 8.83691 30.17V24.045C8.83691 22.365 10.2019 21 11.8994 21Z"
                                    stroke="#01A3D4" stroke-width="2.625" stroke-linecap="round"
                                    stroke-linejoin="round"/>
                                <path d="M21 21V15.75" stroke="#01A3D4" stroke-width="2.625" stroke-linecap="round"
                                      stroke-linejoin="round"/>
                                <path d="M21 38.5V33.25" stroke="#01A3D4" stroke-width="2.625" stroke-linecap="round"
                                      stroke-linejoin="round"/>
                                <path d="M15.75 38.5H26.25" stroke="#01A3D4" stroke-width="2.625" stroke-linecap="round"
                                      stroke-linejoin="round"/>
                            </svg>

                            <span className={"aboutus_title_sec_c"}>شعار ما</span>
                            <p className={"aboutus_desc_sec_c"}>
                                شعار ما در بازارانو به سادگی و به وضوح نشان‌دهنده تعهد ما به تسهیل فرآیند خرید عمده و
                                ارتباطات تجاری است. ما باور داریم که با ایجاد یک پلتفرم آنلاین مطمئن و کارآمد، می‌توانیم
                                به خریداران عمده و فروشندگان عمده کمک کنیم تا بدون واسطه و به‌راحتی به یکدیگر دسترسی
                                پیدا کنند. هدف ما این است که با حذف موانع و تسهیل ارتباطات، هر کسب‌وکاری بتواند به راحتی
                                نیازهای خود را تامین کند و از مزایای خرید عمده بهره‌مند شود.

                                <br/>
                                <br/>
                                شعار ما همچنین تأکیدی بر کیفیت و تنوع خدماتی است که در بازارانو ارائه می‌دهیم. ما به دنبال آن هستیم که با بهره‌گیری از تکنولوژی‌های نوین و بسترهای تبلیغاتی موثر، زمینه‌ساز توسعه کسب‌وکارها و بهبود فرآیندهای خرید عمده باشیم. با تمرکز بر ارتباط مستقیم بین خریداران عمده و فروشندگان عمده ، ما به ایجاد یک بازار پویا و شفاف کمک می‌کنیم که در آن همه بتوانند با اطمینان و رضایت کامل، به تجارت بپردازند.

                            </p>
                        </Grid>

                        <Grid className={"sec_desctiption_and_img_left"} item xs={12} md={6}>
                            <img src={`${imgBaseUrl}images/aboutus/4.png`} alt="Vision" style={{width: '100%'}}/>
                        </Grid>
                    </Grid>


                </Box>


            </Master_Front>

        </Fragment>
    );
}

export default About_Us;